import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__down",
  "use": "icon__down-usage",
  "viewBox": "0 0 15 8",
  "content": "<symbol viewBox=\"0 0 15 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__down\"><title>Path</title><path d=\"M14.303 0a.688.688 0 0 0-.475.204l-6.33 6.189L1.17.204A.689.689 0 0 0 .05.418a.655.655 0 0 0 .156.728l6.811 6.659c.266.26.697.26.963 0l6.811-6.659a.655.655 0 0 0 .157-.736.682.682 0 0 0-.645-.41z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol